import { isEmail, isPhoneNumber, registerDecorator } from 'class-validator';
export function IsEmailOrPhone(validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            name: 'isEmailOrPhone',
            target: object.constructor,
            propertyName,
            constraints: [],
            options: validationOptions,
            validator: {
                validate(value) {
                    return typeof value === 'string' && (isEmail(value) || isPhoneNumber(value, null));
                },
            },
        });
    };
}
//# sourceMappingURL=IsEmailOrPhone.js.map